"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDiscount = void 0;
const hasDiscount = (item) => {
    const { salePrice, discountPrice, price } = item;
    return discountPrice > salePrice || price > discountPrice;
};
exports.hasDiscount = hasDiscount;
